import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Check, ArrowRight, Loader2, PartyPopper } from 'lucide-react';
import confetti from 'canvas-confetti';

export default function BillingSuccessPage() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate verification delay
    const timer = setTimeout(() => {
      setLoading(false);
      
      // Trigger confetti
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ['#10b981', '#34d399', '#6ee7b7', '#ffffff'],
      });
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-emerald-400 animate-spin mx-auto mb-4" />
          <p className="text-zinc-400">Vérification du paiement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="relative mb-8">
          <div className="w-24 h-24 bg-emerald-500 rounded-full flex items-center justify-center mx-auto shadow-lg shadow-emerald-500/30">
            <Check className="w-12 h-12 text-white" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center">
            <PartyPopper className="w-4 h-4 text-yellow-900" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-white mb-4">
          Bienvenue dans la famille !
        </h1>
        
        <p className="text-zinc-400 mb-8 text-lg">
          Votre abonnement est maintenant actif. Vous avez accès à toutes les fonctionnalités de votre plan.
        </p>

        {/* Features unlocked */}
        <div className="bg-zinc-900 rounded-xl border border-zinc-800 p-6 mb-8 text-left">
          <h3 className="text-sm font-medium text-zinc-400 uppercase mb-4">
            Fonctionnalités débloquées
          </h3>
          <ul className="space-y-3">
            <li className="flex items-center gap-3 text-zinc-300">
              <Check className="w-5 h-5 text-emerald-400" />
              Agents IA illimités
            </li>
            <li className="flex items-center gap-3 text-zinc-300">
              <Check className="w-5 h-5 text-emerald-400" />
              Base de connaissances avancée
            </li>
            <li className="flex items-center gap-3 text-zinc-300">
              <Check className="w-5 h-5 text-emerald-400" />
              Intégrations premium
            </li>
            <li className="flex items-center gap-3 text-zinc-300">
              <Check className="w-5 h-5 text-emerald-400" />
              Support prioritaire
            </li>
          </ul>
        </div>

        {/* CTA */}
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-500 text-white font-semibold rounded-xl hover:bg-emerald-400 transition-colors shadow-lg shadow-emerald-500/20"
        >
          Accéder à mon espace
          <ArrowRight className="w-5 h-5" />
        </Link>

        {/* Help link */}
        <p className="mt-6 text-sm text-zinc-500">
          Une question ?{' '}
          <a href="mailto:support@totemai.com" className="text-emerald-400 hover:underline">
            Contactez le support
          </a>
        </p>
      </div>
    </div>
  );
}
